<app-nav></app-nav>

<section class="container-fluid we_are_anima">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-8 d-flex justify-content-end">
                <h2>We are anima</h2>
            </div>
            <div class="col-12 col-md-1">
            </div>
            <div class="col-3">
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-8 text d-flex align-items-end mb-5">
                <p class="pad">
                    Anima was born out of Beehiveor, a leading neuroscientific R&D center founded by Dr. Sergiy Danylov,
                    a Ph.D. in Neuroscience. Since its inception in 2016, Beehiveor has been at the forefront of
                    neuroscientific research, amassing a significant database and expertise in the analysis of an eye
                    movement behavior. Our foundation in rigorous scientific inquiry has equipped us with the tools to
                    understand the intricate relationship between eye movements and mental states, setting the stage for
                    the creation of Anima.
                </p>
                <p class="pad">
                    The landscape changed dramatically for Beehiveor—and for Ukraine—in February 2022, when war erupted
                    on a full scale.
                </p>

                <div class="accent">
                    <p>
                        Recognizing the urgent need for mental health support in these unprecedented times, Beehiveor
                        pivoted its operations to focus entirely on providing practical, evidence-based, remote, and
                        safe screening of mental states.
                    </p>
                </div>
                <p class="pad">
                    This shift in focus was not just a business decision; it was a response to the invasion of our
                    homeland, a way to apply our scientific expertise to address an immediate and pressing need. It was
                    in this crucible of crisis and innovation that Anima was forged, embodying our commitment to mental
                    well-being through scientifically-backed technology.
                </p>
                <p class="pad">
                    Millions of individuals, young and old, were suddenly stressed and dealing with traumas and fears
                    that impaired their mental health. The scale of the war surprised everyone. Nobody knew how to
                    answer "How are you doing?" honestly. Anima was created to answer this question.
                </p>
                <div class="line"></div>
            </div>
            <div class="col-12 col-md-1 ">
            </div>
            <div class="col-12 col-md-3 sidebar ">
                <div class="share">
                    <app-result-share-links class="mb-4"></app-result-share-links>
                    <ng-container *ngIf="!subscribed; else uns">
                        <input type="email" placeholder="mailto:yourmail@gmail.com"/>
                        <div class="agree">
                            <input type="checkbox" name="checkbox"/>
                            <span>I agree to the terms and conditions</span>
                        </div>
                        <button class="action hover_action" (click)="subscribe()">
                            <span>Subscribe</span>
                            <img src="./assets/img/chevron-right.svg" alt="chevron-right">
                        </button>
                    </ng-container>
                    <ng-template #uns>
                        <button class="action hover_action" (click)="unsuscribe()">
                            <span>Unsubscribe</span>
                            <img src="./assets/img/chevron-right.svg" alt="chevron-right">
                        </button>
                    </ng-template>
                </div>
                <div class="d-flex justify-content-end mb-5">
                    <picture class="main-img">
                        <source media="(max-width: 799px)" srcset="assets/img/mon1_1x.webp"/>
                        <source media="(min-width: 800px)" srcset="assets/img/mon1_2x.webp"/>
                        <img src="assets/img/mon1_2x.webp" alt="anima monitor"/>
                    </picture>
                </div>
                <div></div>
            </div>
        </div>
    </div>
</section>
<section class="container-fluid ">
    <div class="container">
        <div class="row mb-4">
            <div class="col-12 col-md-8 d-flex justify-content-end">
                <h2>Our partners</h2>
            </div>
            <div class="col-12 col-md-1">
            </div>
            <div class="col-12 col-md-3"></div>
        </div>
        <div class="row">
            <div class="col-12 col-md-2"></div>
            <div class="col-12 col-md-7">
                <div class="partners">
                    <div class="partners-item">
                        <div class="logo">
                            <img src="./assets/img/bee.png">

                        </div>
                        <div class="text">
                            <p>a neurobiology research and neurotechnology center aiding studies of human
                                behavior.</p>
                        </div>
                    </div>

                    <div class="partners-item">
                        <div class="logo">
                            <img src="./assets/img/ai.png">

                        </div>
                        <div class="text">
                            <p>a marketing and business consulting center helping businesses grow.</p>
                        </div>
                    </div>

                    <div class="partners-item">
                        <div class="logo">

                            <img src="./assets/img/vh.png">
                        </div>
                        <div class="text">
                            <p>an organization to help veterans reintegrate into civilian life after military
                                service.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3"></div>
        </div>
        <div class="row mb-5">
            <div class="col-12 col-md-2">
            </div>
            <div class="col-12 col-md-10">
                <div class="row mb-2">
                    <div class="col-12 col-md-4">
                        <div class="d-flex align-items-end mb-5">
                            <picture>
                                <source media="(max-width: 799px)" srcset="assets/img/danilov_1x.webp"/>
                                <source media="(min-width: 800px)" srcset="assets/img/danilov_2x.webp"/>
                                <img width="110px" src="assets/img/danilov_2x.webp" alt="Serhiy Danilov"/>
                            </picture>

                            <p class="m-0 ml-3">
                                <b>Serhiy Danilov</b><br>
                                <small>Ph.D. in Neurobiology,<br>
                                    Co-founder of Anima. </small>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-8 border-left quote-text">
                        <svg class="quote-icon" width="43" height="34" viewBox="0 0 43 34" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M25.4 33.1V12.1C25.4 2.3 32.1 -9.53674e-07 35.6 -9.53674e-07H42.8V9H39.2C35.5 9 34.9 11.7 34.9 12.7V16.1H42.8V33.1H25.4ZM0.7 33.1V12.1C0.7 2.3 7.4 -9.53674e-07 10.9 -9.53674e-07H18.1V9H14.5C10.7 9 10.2 11.8 10.2 12.7V16.1H18.1V33.1H0.7Z"
                                  fill="#10082F"/>
                        </svg>
                        Increased attention to the threat is a predictive marker of anxiety disorder and depression
                        onset. We can see the essence of this process by measuring eye movement, as the oculomotor and
                        attention functions are tightly integrated on a neural level.
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-12 col-md-3">
            </div>
            <div class="col-12 col-md-6 mb-2">
                <p>Anima is a unique test that helps you track, understand, and resolve your mental and emotional state
                    with emphasis on your attention setting and practical suggestions how to refocus if needed. Using
                    just 10 minutes of your time, Anima assesses your reaction to emotional stimuli and measures how
                    susceptible you are to mental health disorders. Our testing protocol uses eye-tracking to measure
                    attention bias, making it one of the most cutting-edge and rigorous evaluation methods available.
                    Webcams record eye movements to measure one's focus in response to different stimuli. Considering
                    anxiety and depression shared features such as heightened stress vulnerability, emotional
                    dysregulation, and altered reward perception. These fundamental mechanisms can be distorted or
                    dysfunctional in both disorders, leading to common symptoms like irritability, fatigue, and sleep
                    disturbances. Our approach helps explain symptom overlap across different disorders. Anima is not a
                    diagnostic tool; instead of focusing on conventional diagnoses, we aim to comprehend core
                    psychological mechanisms, shifting the focus from traditional disorder labels to the mechanisms
                    underlying their development. In addition to test results, Anima offers recommendations on
                    maintaining productivity, mental health, and well-being.</p>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-12 col-md-2">
            </div>
            <div class="col-12 col-md-10">
                <div class="row mb-2">
                    <div class="col-12 col-md-4">
                        <div class="d-flex align-items-end mb-5">
                            <picture>
                                <source media="(max-width: 799px)" srcset="assets/img/havrysh_1x.webp"/>
                                <source media="(min-width: 800px)" srcset="assets/img/havrysh_2x.webp"/>
                                <img width="110px" src="assets/img/havrysh_2x.webp" alt="Roman Havrysh"/>
                            </picture>
                            <p class="m-0 ml-3">
                                <b>Roman Havrysh</b><br>
                                <small>CEO and Co-founder of Anima.</small>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-8 border-left quote-text">
                        <svg class="quote-icon" width="43" height="34" viewBox="0 0 43 34" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M25.4 33.1V12.1C25.4 2.3 32.1 -9.53674e-07 35.6 -9.53674e-07H42.8V9H39.2C35.5 9 34.9 11.7 34.9 12.7V16.1H42.8V33.1H25.4ZM0.7 33.1V12.1C0.7 2.3 7.4 -9.53674e-07 10.9 -9.53674e-07H18.1V9H14.5C10.7 9 10.2 11.8 10.2 12.7V16.1H18.1V33.1H0.7Z"
                                  fill="#10082F"/>
                        </svg>
                        While conducting tests in mental health hospitals, we saw firsthand the transformative power of
                        understanding one's own mental state. The simple act of taking our test and receiving results
                        offered patients a sense of resolution and clarity. This experience underscored for us the
                        profound impact of knowledge. Being able to lift the veil on the inner mechanics of our psyche
                        allows us to meet our true selves, however daunting that may be. It's this self-awareness that
                        empowers individuals to make the necessary adjustments in their lives, and that's what Anima is
                        all about.
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-12 col-md-9 d-flex justify-content-end">
                <picture class="main-img">
                    <source media="(max-width: 799px)" srcset="assets/img/prof_1x.webp"/>
                    <source media="(min-width: 800px)" srcset="assets/img/prof_2x.webp"/>
                    <img src="assets/img/prof_2x.webp" alt="anima monitor"/>
                </picture>
            </div>
            <div class="col-12 col-md-3">
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-8 mb-2 d-flex justify-content-end">
                <p class="pad">
                    At Anima, our values are the bedrock of our mission to revolutionize mental health assessments. We
                    are steadfastly committed to scientific integrity, ensuring that our eye-tracking technology and
                    methodologies are evidence-based and rigorously validated. Coupled with this is our deep sense of
                    empathy and compassion, which drives us to create a non-judgmental and safe space for mental
                    well-being. We prioritize accessibility, offering remote, web-based services to reach individuals
                    wherever they are, especially in times of urgent need. Privacy and security are paramount; we employ
                    cutting-edge measures to protect sensitive mental health data. Committed to continuous improvement,
                    we're continually refining our services through ongoing R&D, while our sense of social
                    responsibility propels us to use our technology for the greater good.
                </p>
            </div>
            <div class="col-12 col-md-1"></div>
            <div class="col-12 col-md-3">
                <picture>
                    <source media="(max-width: 799px)" srcset="assets/img/mon2_1x.webp"/>
                    <source media="(min-width: 800px)" srcset="assets/img/mon2_2x.webp"/>
                    <img src="assets/img/mon2_2x.webp" alt="anima monitor"/>
                </picture>
            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>
